import React from "react"
import { List } from "semantic-ui-react"

const ApplicationBullets = ({ ama }) => {
  return (
    <List bulleted>
      <List.Item>
        Έχω λάβει γνώση της αναλυτικής μοριοδότησης και της ατομικής καρτέλας
        μου και ενημερώθηκα για τις οδηγίες και τις τεθείσες προθεσμίες, όπως
        αυτές καθορίζονται στη Διαταγή Μεταθέσεων Έτους{" "}
        {process.env.REACT_APP_YEAR}.
      </List.Item>
      <List.Item>
        Πιστοποιώ ότι τα παραπάνω στοιχεία είναι αληθή και επέχουν θέση
        Υπεύθυνης Δήλωσης.
      </List.Item>

      {/* EKSOTERIKOU <List.Item>
          Έχω ελέγξει την ορθότητα της μοριοδότησης μου όπως αυτή απεικονίζεται
          στην ηλεκτρονική εφαρμογή του MIS/ΓΕΑ "Ατομική Ενημέρωση Στρ.
          Προσωπικού", και εφόσον έχω ενστάσεις θα τις υποβάλλω μέχρι την 14η
          Δεκ 20 στο ΓΕΑ/Β1.
        </List.Item> */}
      <List.Item>
        <span style={{ fontWeight: "bold" }}>AMA : {ama}</span>
      </List.Item>
    </List>
  )
}

export default ApplicationBullets
